export default {
  M_LOADING (state, payload) {
    state.IS_LOADING = payload
  },
}
